export const LeaveHeader = [
  {
    name: "Date",
    field: "createdAt",
  },

  {
    name: "Name",
    field: "user_name",
  },

  {
    name: "Leave Type",
    field: "leave_type",
  },
  {
    name: "Date Range",
    field: "date_range",
  },
  {
    name: "Total Days",
    field: "total_days",
  },
  {
    name: "Reason",
    field: "comments",
  },
  {
    name: "Action",
    field: "is_status",
  },
];

export const LeaveTableData = [
  {
    Department: "Information Technology",
    Designation: "Software Engineer",
    Action: "Edit",
  },
  {
    Department: "Information Technology",
    Designation: "Software Engineer",
    Action: "Edit",
  },
  {
    Department: "Information Technology",
    Designation: "Software Engineer",
    Action: "Edit",
  },
  {
    Department: "Information Technology",
    Designation: "Software Engineer",
    Action: "Edit",
  },
];
